import {Injectable, Inject, PLATFORM_ID} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {isPlatformBrowser} from '@angular/common';
import {NavigationStart, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private display: BehaviorSubject<'open' | 'close'> = new BehaviorSubject<'open' | 'close'>('close');

  constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {
    // Close any open modal when the user navigates to another page (link, dropdown or back button)
    if (isPlatformBrowser(this.platformId)) {
      this.router.events
        .pipe(
          filter(event => event instanceof NavigationStart),
          takeUntilDestroyed()
        )
        .subscribe(() => {
          if (this.display.value === 'open') {
            this.close();
          }
        });
    }
  }

  watch(): Observable<'open' | 'close'> {
    return this.display.asObservable();
  }

  open() {
    document.body.style.position = 'fixed';
    document.body.style.top = `-${window.scrollY}px`;
    this.display.next('open');
  }

  close() {
    document.body.style.position = '';
    document.body.style.top = '';
    this.display.next('close');
  }
}